<template>
  <div id="ch_popup_candy" class="mfp-hide white-popup-block">
    <div class="candypop" v-if="d_candy">
      <template v-if="!c_product_discount_bbva">
        <div class="candypop-title">
          <span>{{ d_candy.strTitle }}</span>
        </div>
        <div class="candypop-galery" v-if="d_candy.JsonImages && Array.isArray(d_candy.JsonImages)">
          <div ref="slider" class="candypop-galery-inner">
            <div v-for="(data, index) in d_candy.JsonImages" :key="index">
              <div class="galery-image">
                <a @click.prevent="m_show_gallery(d_candy)">
                  <img :src="getImageUrl(data.Image)" @error="onImageChangeExtension()" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!c_product_ypf" class="candypop-description">
          <span>{{ d_candy.strDescription }}<span v-html="m_get_discountbytitle()"></span></span>
        </div>
        <div v-else class="candypop-ypfserviclub">
          <span>{{ d_candy.strDescription }}</span>
          <br><br>
          <span class="bold">SOCIO YPF SERVICLUB</span><br><span>Canjeá tus KMS por descuentos</span>
        </div>
        <div v-if="!c_product_ypf" class="candypop-cuotas">
          <span>3 cuotas sin interes con</span>
          <img :src="$root.d_get_url_merch + 'images/bbva.png?v=' + $root.d_get_date_version_cache" />
        </div>
        <div class="candypop-box">
          <template v-if="$root.d_member">
            <div class="candypop-prices">
              <template v-if="!c_product_ypf">
                <span>PRECIOS</span>
                <template v-if="$root.d_member.intLoyaltyLevel == 1"></template>
                <template v-else-if="$root.d_member.intLoyaltyLevel == 2">
                  <img :src="$root.d_get_url_merch + 'images/logo-clubfan.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
                </template>
                <template v-else-if="$root.d_member.intLoyaltyLevel == 3">
                  <img :src="$root.d_get_url_merch + 'images/logo-clubplus.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
                </template>
                <template v-else>
                  <img :src="$root.d_get_url_merch + 'images/logo-clubblack.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
                </template>
              </template>
              <template v-else>
                <span>PRECIO YPF SERVICLUB</span>
              </template>
            </div>
          </template>
          <div class="candypop-options">
            <div v-for="(level, index) in c_levels_buy_options" :key="index" class="candypop-options-group">
              <template v-if="!$root.d_member">
                <div class="candypop-option-logos">
                  <template v-if="!c_product_ypf">
                    <img :src="$root.d_get_url_merch + 'images/candy-option-level-' + level + '.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
                  </template>
                  <template v-else>
                    <span>PRECIO YPF SERVICLUB</span>
                  </template>
                </div>
              </template>
              <div v-for="(option, index) in m_filter_buy_options(level)" :key="index" class="candypop-option">
                <div class="candypop-option-content" @click.prevent="m_select_cinema(option.intRecogId, option.intType, option.intPromoId)">
                  <div class="candypop-option-content-description">
                    <div class="middle">
                      <!-- RETIRO PRECIOS TACHADOS -->
                      <!--<span class="ticket-price-before" v-if="m_validate_show_price_before(option)">${{ d_candy.PercentDiscount == 0 ? (d_candy.SalePrice / 100).toLocaleString('es-AR') : d_candy.SalePrice }}&nbsp;</span>-->
                      <span v-html="m_total(option)"></span>
                      <small v-if="$root.d_show_promotion_desc && option.intPromoId != 0">{{ option.strDescription }}</small>
                    </div>
                  </div>
                  <div class="candypop-option-content-button">
                    <a :class="{ 'ticket-price-selected': m_get_ticket_candy_qty(option) > 0 }" :alt="option.strDescription" href="#" title="Agregar al Carrito">
                      <img :src="$root.d_get_url_merch + 'images/cart.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
                    </a>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="candypop-button">
            <div class="row">
              <div class="col-xs-12">
                <a @click.prevent="closeModal()">VER MAS PRODUCTOS</a>
              </div>
            </div>
          </div>
          <div class="candypop-properties">
            <div class="candypop-properties-description">
              <span>CARACTERÍSTICAS</span>
            </div>
            <div class="candypop-properties-items">
              <table>
                <tr v-for="data in d_candy.jsonExtraData">
                  <td>
                    <span>{{ data.Name }}</span>
                  </td>
                  <td>
                    <span>{{ data.Value }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="candypop-descriptionlarge">
            <div class="candypop-descriptionlarge-title">
              <span>DETALLE DEL PRODUCTO</span>
            </div>
            <div class="candypop-descriptionlarge-description">
              <span>{{ d_candy.strDescriptionLong }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="candypop-title">
          <span>{{ d_candy.strTitle }}</span>
        </div>
        <div class="candypop-galery" v-if="d_candy.JsonImages && Array.isArray(d_candy.JsonImages)">
          <div ref="slider" class="candypop-galery-inner">
            <div v-for="(data, index) in d_candy.JsonImages" :key="index">
              <div class="galery-image">
                <a @click.prevent="m_show_gallery(d_candy)">
                  <img :src="getImageUrl(data.Image)" @error="onImageChangeExtension()" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="candypop-description">
          <span>{{ d_candy.strDescription }}</span>
          <div class="candypop-discount">
            <span v-html="c_product_discount_bbva_msge"></span>
          </div>
        </div>
        <div class="candypop-cuotas">
          <span>3 cuotas sin interes con</span>
          <img :src="$root.d_get_url_merch + 'images/bbva.png?v=' + $root.d_get_date_version_cache" />
        </div>
        <div class="candypop-box">
          <template v-if="$root.d_member">
            <div class="candypop-prices">
              <span>PRECIOS</span>
              <template v-if="$root.d_member.intLoyaltyLevel == 1"></template>
              <template v-else-if="$root.d_member.intLoyaltyLevel == 2">
                <img :src="$root.d_get_url_merch + 'images/logo-clubfan.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
              </template>
              <template v-else-if="$root.d_member.intLoyaltyLevel == 3">
                <img :src="$root.d_get_url_merch + 'images/logo-clubplus.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
              </template>
              <template v-else>
                <img :src="$root.d_get_url_merch + 'images/logo-clubblack.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
              </template>
            </div>
          </template>
          <div class="candypop-options">
            <div v-for="(level, index) in c_levels_buy_options" :key="index" class="candypop-options-group">
              <template v-if="!$root.d_member">
                <div class="candypop-option-logos">
                  <img :src="$root.d_get_url_merch + 'images/candy-option-level-' + level + '.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
                </div>
              </template>
              <div v-for="(option, index) in m_filter_buy_options(level)" :key="index" class="candypop-option">
                <div class="candypop-option-content" @click.prevent="m_select_cinema(option.intRecogId, option.intType, option.intPromoId)">
                  <div class="candypop-option-content-description">
                    <div class="middle">
                      <!-- RETIRO PRECIOS TACHADOS -->
                      <!--<span class="ticket-price-before" v-if="m_validate_show_price_before(option)">${{ d_candy.PercentDiscount == 0 ? (d_candy.SalePrice / 100).toLocaleString('es-AR') : d_candy.SalePrice }}&nbsp;</span>-->
                      <span v-html="m_total(option)"></span>
                      <small v-if="$root.d_show_promotion_desc && option.intPromoId != 0">{{ option.strDescription }}</small>
                    </div>
                  </div>
                  <div class="candypop-option-content-button">
                    <a :class="{ 'ticket-price-selected': m_get_ticket_candy_qty(option) > 0 }" :alt="option.strDescription" href="#" title="Agregar al Carrito">
                      <img :src="$root.d_get_url_merch + 'images/cart.png?v=' + $root.d_get_date_version_cache" class="img-responsive" />
                    </a>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="candypop-button">
            <div class="row">
              <div class="col-xs-12">
                <a @click.prevent="closeModal()">VER MAS PRODUCTOS</a>
              </div>
            </div>
          </div>
          <div class="candypop-properties">
            <div class="candypop-properties-description">
              <span>CARACTERÍSTICAS</span>
            </div>
            <div class="candypop-properties-items">
              <table>
                <tr v-for="data in d_candy.jsonExtraData">
                  <td>
                    <span>{{ data.Name }}</span>
                  </td>
                  <td>
                    <span>{{ data.Value }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="candypop-descriptionlarge">
            <div class="candypop-descriptionlarge-title">
              <span>DETALLE DEL PRODUCTO</span>
            </div>
            <div class="candypop-descriptionlarge-description">
              <span>{{ d_candy.strDescriptionLong }}</span>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import $ from "jquery";

require("./../assets/jquery.bpopup.min.js");
require('slick-carousel');

export default {
  name: "popupcandyhome",
  props: {
    d_candy: { type: Object, default: () => null }
  },
  computed: {
    c_candy: {
      get() {
        return this.d_candy;
      },
      set(a) {
        this.d_candy = a;
      }
    },
    c_product_ypf: function () {
      var is_product_ypf = false;

      this.d_candy.BuyOptions.forEach(buyoption => {
        if (buyoption.intType == 4) {
          is_product_ypf = true;
        }
      });

      return is_product_ypf;
    },
    c_product_discount_bbva: function () {
      var is_product_discount_bbva = false;

      var productList = this.$root.d_get_discount_bbva_product_list.split(';');

      productList.forEach(product => {
        if (product != '' && product == this.d_candy.strMCode) {
          is_product_discount_bbva = true;
        }
      });

      return is_product_discount_bbva;
    },
    c_product_discount_bbva_msge: function () {
      var message = "";

      var productMsgs = this.$root.d_get_discount_bbva_product_msgs.split(';;');

      productMsgs.forEach(productMsg => {
        var productMsgList = productMsg.split('--');

        if (productMsgList[0] != '' & productMsgList[0] == this.d_candy.strMCode) {
          message = productMsgList[1];
        }
      });

      return message;
    },
    c_levels_buy_options() {
      const intLevels = [];

      this.d_candy.BuyOptions.forEach(buyoption => {
        if (intLevels.indexOf(buyoption.intLevel) === -1) {
          intLevels.push(buyoption.intLevel);
        }
      });

      return intLevels;
    }
  },
  methods: {
    closeModal(){
      $.magnificPopup.close();
    },
    getImageUrl(imageName) {
      let baseUrl = this.$root.d_get_url_candy_images;
      let version = this.$root.d_get_date_version_cache;
      return `${baseUrl}${imageName}?v=${version}`;
    },
    onImageChangeExtension() {
      //let url = event.target.src
      //const newUrl = url.replace(".gif", ".png");
      //event.target.src = newUrl
    },
    //Seteo el object con los atributos a mostrar.
    m_open: function (args) {
      this.d_candy = args;

      this.$root.m_init_magnific_popup('#ch_popup_candy', '.candypop-galery-inner', 'inline', 'mf-pop-candy', true);
    },
    m_filter_buy_options(level) {
      return this.d_candy.BuyOptions.filter((option) => option.intLevel === level);
    },
    m_select_cinema: function (intRecogId, intRecogTypeId, intPromoId) {
      this.$root.m_show_popup_cinemas_home(this.d_candy, intRecogId, intRecogTypeId, intPromoId, null);
    },
    m_del_candy: function (intRecogId, intPromoId) {
      this.$root.m_del_candy(this.d_candy.strMCode, this.d_candy.strBarcode, intRecogId, intPromoId);
    },
    m_total: function (option) {
      var price = "";
      var balances = "";
      var hasPoints = false;

      if (option.intValue > 0) {
        if (!this.$root.d_member) {
          if (option.intRecogId > 0) {
            price += `<span class="ticket-price-now">$ ${((option.intValue * option.intButtonQty)).toLocaleString('es-AR')}</span>`;
          }
          else {
            price += `<span class="ticket-price-now">$ ${((option.intValue * option.intButtonQty) / 100).toLocaleString('es-AR')}</span>`;
          }
        }
        else {
          price += `<span class="ticket-price-now">$ ${((option.intValue * option.intButtonQty) / 100).toLocaleString('es-AR')}</span>`;
        }
      }

      if (option.lstBalances.length == 1) {
        option.lstBalances.forEach(balance => {
          if (balance.intPoints > 0) {
            hasPoints = true;
            balances += `<span class="ticket-price-now">${balance.intPoints.toLocaleString('es-AR')}</span>&nbsp;<small class="ticket-price-span">${this.m_get_balance_name(balance.enuPointsType, balance.intBalanceId, (balance.intPoints > 1))}</small>`;
          }
        });
      }

      if (option.lstBalances.length > 1) {
        option.lstBalances.forEach(balance => {
          if (balance.intPoints > 0) {
            hasPoints = true;

            if (balances.length > 0) {
              balances += " + ";
            }

            balances += `&nbsp;<small class="ticket-price-span">${balance.intPoints.toLocaleString('es-AR')} ${this.m_get_balance_name(balance.enuPointsType, balance.intBalanceId, (balance.intPoints > 1))}</small>`;
          }
        });
      }

      if (!hasPoints && option.intValue == 0) {
        price = '$0';
      }

      if (hasPoints && option.intValue > 0) {
        price += ' + ';
      }

      var priceDesc = "";

      if (this.$root.d_member && this.$root.d_member.intLoyaltyLevel > 1 && option.intType == 3 && option.intRecogId != 0 && option.intPromoId == 0) {
        priceDesc = `&nbsp;<span class="ticket-price-span"></span>`;
      }
      else {
        if (this.m_validate_show_price_before(option)) {
          priceDesc = `&nbsp;<span class="ticket-price-span"></span>`;
        }
      }

      return price + balances + priceDesc;
    },
    m_get_ticket_candy_qty: function (option) {
      return this.$root.m_get_ticket_candy_qty(this.d_candy.strMCode, this.d_candy.strBarcode, option.intRecogId, option.intPromoId);
    },
    m_validate_show_price_before(option) {
      var resp = false;

      if (option.intValue == 0)
        return false;

      if (option.intType == 3) {
        if ((option.intRecogId != 0 && this.d_candy.SalePrice > option.intValue)) {
          resp = true;
        }
        else if ((option.intPromoId != 0 && this.d_candy.SalePrice > option.intValue)) {
          resp = true;
        }
        else if (this.d_candy.PercentDiscount != 0 && this.d_candy.SalePrice * 100 > option.intValue) {
          resp = true;
        }
      }

      return resp;
    },
    m_getDate: function () {
      return moment();
    },
    m_get_balance_name: function (enuPointsType, intBalanceId, plural) {
      return this.$root.m_get_balance_name(enuPointsType, intBalanceId, false, plural);
    },
    m_show_gallery: function (p_candy) {
      this.$root.m_show_popup_gallery_home(p_candy);
    },
    m_get_discountbytitle: function () {
      var plist = this.$root.d_get_discount_msg_productlist.split(';;');
      var message = "NO";
      var msgdefault = "";

      plist.forEach(p => {
        if (p.includes(this.d_candy.strMCode)) {
          var mcode_msg = p.split('--');
          message = `<br/><br/>` + mcode_msg[1];
        }
      });

      if (message == "NO") {
        return msgdefault;
      }
      else {
        return message;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PopupCandyHome.vue